import { features } from "assets"
import routes from "./routes"

const homeCareConfig = {
  name: "homeCare",
  type: "feature",
  defaultRoute: "/userhome/dashboard/home_care",
  menuIcon: {
    img: features.homeCare.main,
    alt: "home_care_feature_icon",
  },
  nav: routes,
  tableView: {
    headers: ["date", "category", "activity"],
    mobileHeaders: ["date", "category", "activity"],
  },
  chartView: {},
}

export default homeCareConfig
